import React from "react";
import "./AllProduct.css";
import xten from "../../assets/xten-logo-footer.png";
import Power from "../../assets/All-Product/mini-card/1_Power.png";
import Water from "../../assets/All-Product/mini-card/2_Water.png";
import Air from "../../assets/All-Product/mini-card/3_Air.png";
import CCTV from "../../assets/All-Product/mini-card/4_CCTV.png";
import Room from "../../assets/All-Product/mini-card/5_Room.png";
import Lighting from "../../assets/All-Product/mini-card/6_Lighting.png";
import Parking from "../../assets/All-Product/mini-card/7_Parking.png";
import UPS from "../../assets/All-Product/mini-card/8_UPS.png";

function AllProduct() {
  return (
    <div>
      <div className="header-all-product">
        <div className="iot-solutions-content">
          <div className="iot-solutions-text">
            <div className="iot-solutions-header">All Products</div>
            <div className="iot-solutions-sub">
              Norem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
              vulputate libero et velit interdum, ac aliquet odio mattis. Class
              aptent taciti sociosqu ad litora torquent per conubia nostra, per
              inceptos himenaeos.
            </div>
            <div className="iot-solution-button">
              <a href="/" className="read-more-btn-1">
                Read More
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-content-all-product">
        <div className="content-all-product">
          <div className="content-head-all-product">
            <div className="xten-detail-content-head">
              <div className="header-xten-all-product">XTEN All Products</div>
              <div className="sub-xten-all-product">
                Qorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
                eu turpis molestie, dictum est a, mattis tellus. Sed dignissim,
                metus nec fringilla accumsan, risus sem sollicitudin lacus, ut
                interdum tellus elit sed risus. Maecenas eget condimentum velit,
                sit amet feugiat lectus. Class aptent taciti sociosqu ad litora
                torquent per conubia nostra, per inceptos himenaeos. Praesent
                auctor purus luctus enim egestas, ac scelerisque ante pulvinar.
              </div>
            </div>
            <div className="content-logo-all-product">
              <img src={xten} alt="" />
            </div>
          </div>
          <div className="content-product-text">
            <div className="detail-product">
              <div className="detail-product-content">
                <div className="detail-product-content-head">Power Meter</div>
                <div className="detail-product-content-sub">
                  Qorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                  vulputate libero et velit interdum, ac aliquet odio mattis.
                  Class aptent taciti sociosqu ad litora torquent per conubia
                  nostra, per inceptos himenaeos.
                </div>
              </div>
              <div className="detail-product-content">
                <div className="detail-product-content-head">Water Meter</div>
                <div className="detail-product-content-sub">
                  Qorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                  vulputate libero et velit interdum, ac aliquet odio mattis.
                  Class aptent taciti sociosqu ad litora torquent per conubia
                  nostra, per inceptos himenaeos.
                </div>
              </div>
              <div className="detail-product-content">
                <div className="detail-product-content-head">
                  Air Quality Sensor
                </div>
                <div className="detail-product-content-sub">
                  Qorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                  vulputate libero et velit interdum, ac aliquet odio mattis.
                  Class aptent taciti sociosqu ad litora torquent per conubia
                  nostra, per inceptos himenaeos.
                </div>
              </div>
            </div>
            <div className="detail-product">
              <div className="detail-product-content">
                <div className="detail-product-content-head">CCTV</div>
                <div className="detail-product-content-sub">
                  Qorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                  vulputate libero et velit interdum, ac aliquet odio mattis.
                  Class aptent taciti sociosqu ad litora torquent per conubia
                  nostra, per inceptos himenaeos.
                </div>
              </div>
              <div className="detail-product-content">
                <div className="detail-product-content-head">
                  Conference Room
                </div>
                <div className="detail-product-content-sub">
                  Qorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                  vulputate libero et velit interdum, ac aliquet odio mattis.
                  Class aptent taciti sociosqu ad litora torquent per conubia
                  nostra, per inceptos himenaeos.
                </div>
              </div>
              <div className="detail-product-content">
                <div className="detail-product-content-head">UPS</div>
                <div className="detail-product-content-sub">
                  Qorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                  vulputate libero et velit interdum, ac aliquet odio mattis.
                  Class aptent taciti sociosqu ad litora torquent per conubia
                  nostra, per inceptos himenaeos.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="product-all-list">
          <div className="iot-solutions-list-header">Products List</div>
          <div className="iot-solutions-list-content">
            <div className="sub-carf-content-iot-solutions">
              <img
                src={Power}
                alt=""
                className="image-sub-card-iot-solutions"
              />
              <div className="text-sub-carf-content-image-iot-solutions">
                <div className="box-text-annoutment-iot-solutions">
                  <div className="box-text-head-carf-content-iot-solutions">
                    Power Meter
                  </div>
                  <div className="box-text-sub-carf-content-iot-solutions">
                    Borem ipsum dolor sit amet, consectetur adipiscing elit.
                    Nunc vulputate libero et velit interdum, ac aliquet odio
                    mattis. Class aptent taciti sociosqu ad litora torquent per
                    conubia nostra, per inceptos himenaeos.
                  </div>
                </div>
              </div>
            </div>
            <div className="sub-carf-content-iot-solutions">
              <img
                src={Water}
                alt=""
                className="image-sub-card-iot-solutions"
              />
              <div className="text-sub-carf-content-image-iot-solutions">
                <div className="box-text-annoutment-iot-solutions">
                  <div className="box-text-head-carf-content-iot-solutions">
                  Water Meter
                  </div>
                  <div className="box-text-sub-carf-content-iot-solutions">
                    Borem ipsum dolor sit amet, consectetur adipiscing elit.
                    Nunc vulputate libero et velit interdum, ac aliquet odio
                    mattis. Class aptent taciti sociosqu ad litora torquent per
                    conubia nostra, per inceptos himenaeos.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="iot-solutions-list-content">
            <div className="sub-carf-content-iot-solutions">
              <img
                src={Air}
                alt=""
                className="image-sub-card-iot-solutions"
              />
              <div className="text-sub-carf-content-image-iot-solutions">
                <div className="box-text-annoutment-iot-solutions">
                  <div className="box-text-head-carf-content-iot-solutions">
                  Air Quality Sensor
                  </div>
                  <div className="box-text-sub-carf-content-iot-solutions">
                    Qorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Nunc vulputate.
                  </div>
                </div>
              </div>
            </div>
            <div className="sub-carf-content-iot-solutions">
              <img
                src={CCTV}
                alt=""
                className="image-sub-card-iot-solutions"
              />
              <div className="text-sub-carf-content-image-iot-solutions">
                <div className="box-text-annoutment-iot-solutions">
                  <div className="box-text-head-carf-content-iot-solutions">
                  CCTV
                  </div>
                  <div className="box-text-sub-carf-content-iot-solutions">
                    Borem ipsum dolor sit amet, consectetur adipiscing elit.
                    Nunc vulputate libero et velit interdum, ac aliquet odio
                    mattis. Class aptent taciti sociosqu ad litora torquent per
                    conubia nostra, per inceptos himenaeos.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="iot-solutions-list-content">
            <div className="sub-carf-content-iot-solutions">
              <img
                src={Room}
                alt=""
                className="image-sub-card-iot-solutions"
              />
              <div className="text-sub-carf-content-image-iot-solutions">
                <div className="box-text-annoutment-iot-solutions">
                  <div className="box-text-head-carf-content-iot-solutions">
                  Conference Room
                  </div>
                  <div className="box-text-sub-carf-content-iot-solutions">
                    Borem ipsum dolor sit amet, consectetur adipiscing elit.
                    Nunc vulputate libero et velit interdum, ac aliquet odio
                    mattis. Class aptent taciti sociosqu ad litora torquent per
                    conubia nostra, per inceptos himenaeos.
                  </div>
                </div>
              </div>
            </div>
            <div className="sub-carf-content-iot-solutions">
              <img
                src={Lighting}
                alt=""
                className="image-sub-card-iot-solutions"
              />
              <div className="text-sub-carf-content-image-iot-solutions">
                <div className="box-text-annoutment-iot-solutions">
                  <div className="box-text-head-carf-content-iot-solutions">
                  Lighting
                  </div>
                  <div className="box-text-sub-carf-content-iot-solutions">
                    Borem ipsum dolor sit amet, consectetur adipiscing elit.
                    Nunc vulputate libero et velit interdum, ac aliquet odio
                    mattis. Class aptent taciti sociosqu ad litora torquent per
                    conubia nostra, per inceptos himenaeos.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="iot-solutions-list-content">
            <div className="sub-carf-content-iot-solutions">
              <img
                src={Parking}
                alt=""
                className="image-sub-card-iot-solutions"
              />
              <div className="text-sub-carf-content-image-iot-solutions">
                <div className="box-text-annoutment-iot-solutions">
                  <div className="box-text-head-carf-content-iot-solutions">
                  Parking
                  </div>
                  <div className="box-text-sub-carf-content-iot-solutions">
                    Borem ipsum dolor sit amet, consectetur adipiscing elit.
                    Nunc vulputate libero et velit interdum, ac aliquet odio
                    mattis. Class aptent taciti sociosqu ad litora torquent per
                    conubia nostra, per inceptos himenaeos.
                  </div>
                </div>
              </div>
            </div>
            <div className="sub-carf-content-iot-solutions">
              <img
                src={UPS}
                alt=""
                className="image-sub-card-iot-solutions"
              />
              <div className="text-sub-carf-content-image-iot-solutions">
                <div className="box-text-annoutment-iot-solutions">
                  <div className="box-text-head-carf-content-iot-solutions">
                  UPS
                  </div>
                  <div className="box-text-sub-carf-content-iot-solutions">
                    Borem ipsum dolor sit amet, consectetur adipiscing elit.
                    Nunc vulputate libero et velit interdum, ac aliquet odio
                    mattis. Class aptent taciti sociosqu ad litora torquent per
                    conubia nostra, per inceptos himenaeos.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AllProduct;
